import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal, Signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { HandlersService } from 'src/app/api/api/handlers.service';
import { DialogData } from 'src/app/api/model/dialogData';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { Resource } from 'src/app/resources/resource';
import { isPartner } from '../../utils/brand-utils';
import { environment } from 'src/environments/environment';
import { CANAL_VENTE_C } from '../../constants/context.constants';

@Component({
  selector: 'app-vyv-popup',
  standalone: true,
  imports: [CommonModule, ButtonModule, SkeletonModule],
  templateUrl: './vyv-popup.component.html',
  styles: [],
})
export class VyvPopupComponent {
  public resource: Resource;
  public store = inject(CombinedStore);

  loadPhone = signal(false);

  isPartner = isPartner(environment.brand);
  CANAL_VENTE_C = CANAL_VENTE_C;
  VyvPhone = '04 26 31 69 72';

  constructor(
    resources: AppResource,
    public config: DynamicDialogConfig<DialogData>,
    public ref: DynamicDialogRef,
    public handlerService: HandlersService,
  ) {
    this.resource = resources['resource'];

    if (!this.store.contactPhone()) {
      this.loadPhone.set(true);
      this.handlerService.apiHandlersPhoneByProductAndBrandGet().subscribe({
        next: (response) => {
          this.store.updateHandlerContactPhone(response.phone!);
          // this.loadPhone.set(false);
        },
        error: (err) => {
          console.error('Error fetching handler phone:', err);
          // this.loadPhone.set(false);
        },
        complete: () => {
          this.loadPhone.set(false);
        },
      });
    }
  }

  //! to map correctly with the component, please use the DialogData interface
  isCustomContent: Signal<boolean> = computed(() => this.config.data?.isCustom ?? false);

  closePopup() {
    this.ref.close();
  }

  validation() {
    this.ref.close(true);
  }
}

export const VyvPopupConfig: Partial<DynamicDialogConfig> = {
  width: '34.375rem', //550px
  modal: true,
  resizable: false,
  showHeader: false,
};
